import { isValidPhone } from './utils/isValidPhone.js';
import { loadLs, saveLs } from '../../../storage/localStorage.js';
import {
  changeBgColor,
  changeInputsStyled,
} from '../step1/utils/changeInputsStyled.js';
import { API_getCustomer } from '../../../../api/customers/API_getCustomer.js';
import { isValidEmail } from './utils/isValidEmail.js';
import { setCustomerOrderData } from '../orderData.js';

const KEY_LS = 'customer-data';

export let customerData = {
  name: '',
  email: '',
  phone: '',
};

// =====================================
// Функція для оновлення customerData і збереження в localStorage
// =====================================
export const setCustomerData = (data, setLS = true) => {
  Object.assign(customerData, data);
  if (setLS) {
    saveLs(KEY_LS, customerData);
  }
};

// =====================================
// Селектори
// =====================================
const refs = {
  form: document.querySelector('.form-customer'),
  customerPhoneInput: document.getElementById('customer-phone'),
};
const { form, customerPhoneInput } = refs;

// =====================================
// Відновлення даних з localStorage
// =====================================
const customerDataLS = loadLs(KEY_LS);
if (customerDataLS) {
  const { name, email, phone } = customerDataLS;
  customerData = { ...customerData, name, email, phone };

  // Запит на отримання даних клієнта з бекенду
  API_getCustomer({
    phone: customerDataLS.phone,
    email: customerDataLS.email,
  }).then(customer => {
    // console.log('customer', customer);
    if (customer && customer?._id) {
      setCustomerData({ data: { ...customer } }, false);
      setCustomerOrderData({ ...customer });
    }
  });

  // Оновлюємо інпути тільки якщо форма присутня на сторінці
  if (form) {
    Object.entries(customerDataLS).forEach(([name, value]) => {
      if (
        (name === 'name' || name === 'email' || name === 'phone') &&
        value !== ''
      ) {
        const input = form.querySelector(
          `.form-input[name="customer-${name}"]`
        );
        if (input) {
          input.value = value;
          changeBgColor(input);
        }
      }
    });
  }
}

// =====================================
// Слухачі input
// =====================================
// Якщо форми немає на сторінці (інша сторінка), просто нічого не робимо
if (form) {
  form.addEventListener('input', event => {
    const input = event.target;
    if (!input.classList.contains('form-input')) return;

    const { name, value } = input;
    if (
      name === 'customer-name' ||
      name === 'customer-email' ||
      name === 'customer-phone'
    ) {
      const key = name.split('-')[1];
      changeInputsStyled(input, value.trim());
      setCustomerData({ [key]: value.trim() });

      // Якщо це email або телефон, перевіряємо наявність користувача на бекенді
      if (
        ((key === 'email' && isValidEmail(value.trim())) ||
          (key === 'phone' && isValidPhone(value.trim()))) &&
        customerData?.data?.[key] !== value.trim()
      ) {
        API_getCustomer({
          [key]: key === 'phone' ? value.trim() : value.trim(),
        }).then(customer => {
          // console.log('customer', customer);
          if (customer && customer?._id) {
            setCustomerData({ data: { ...customer } }, false);
            setCustomerOrderData({ ...customer });
          }
        });
      }
    }
  });
}
